import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const UserFilters = ({ 
  searchTerm, 
  onSearchChange, 
  roleFilter, 
  onRoleFilterChange,
  onReset 
}) => {
  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'admin', label: 'Administrator' },
    { value: 'accountant', label: 'Accountant' },
    { value: 'manager', label: 'Manager' },
    { value: 'user', label: 'User' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <Input
            type="search"
            placeholder="Search by name or email..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>
        
        <div className="flex gap-2">
          <Select
            options={roleOptions}
            value={roleFilter}
            onChange={onRoleFilterChange}
          />
          <Button
            variant="outline"
            iconName="RotateCcw"
            onClick={onReset}
            aria-label="Reset filters"
          />
        </div>
      </div>
    </div>
  );
};

export default UserFilters;